import React, { useState } from 'react';
import { Alert, Avatar, Box, Button, Link, Paper, Stack, TextField, Typography } from '@mui/material';
import ShieldIcon from '@mui/icons-material/Shield';
import { useLocation } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

type LoginNavigationState = {
  identifier?: string;
  accountCreated?: boolean;
};

const Login: React.FC = () => {
  const location = useLocation();
  const navigationState = (location.state || {}) as LoginNavigationState;
  const [identifier, setIdentifier] = useState(navigationState.identifier || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true); setError('');
    const response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: identifier, password }),
    });
    if (!response.ok) setError('We could not sign you in with those details.');
    else window.location.assign('/dashboard');
    setBusy(false);
  };

  return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#e7ebf1', p: 2 }}>
    <Paper component="form" onSubmit={submit} sx={{ width: '100%', maxWidth: 420, p: 4, borderRadius: 2 }}>
      <Stack spacing={2.5}>
        <Box>
          <Link href="/" underline="none" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, color: '#2450C6', fontWeight: 700, mb: 2 }} aria-label="Return to the Assertion landing page">
            <Avatar variant="rounded" sx={{ width: 38, height: 38, bgcolor: '#E8EEFF', color: '#2450C6' }}><ShieldIcon /></Avatar>
            <Typography component="span" sx={{ color: '#13203A', fontWeight: 800, letterSpacing: '0.03em' }}>ASSERTION</Typography>
          </Link>
          <Typography variant="h4" fontWeight={700}>Sign in to Assertion</Typography><Typography color="text.secondary" sx={{ mt: 1 }}>Regulatory intelligence for your consent programme.</Typography>
        </Box>
        {navigationState.accountCreated && <Alert severity="success">Your account is ready. Sign in with your new username.</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Email or username" value={identifier} onChange={e => setIdentifier(e.target.value)} autoComplete="username" required autoFocus={!identifier} />
        <TextField label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required autoFocus={Boolean(identifier)} />
        <Button type="submit" variant="contained" size="large" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</Button>
      </Stack>
    </Paper>
  </Box>;
};

export default Login;
